import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Brep extends OBase {
  update () {
    let valTree = this.getObjectInput('Brep');
    let pOutput = this.getGenericObjectOutput('Brep');

    var outTree = new Geometry.DataTree();

    for (let i = 0; i < valTree.branches.length; i++) {
      outTree.addEmpty(valTree.paths[i]);
      for (let j = 0; j < valTree.branches[i].length; j++) {
        let val = valTree.branches[i][j];
        outTree.add(val, valTree.paths[i]);
      }
    }

    pOutput.value = outTree;
  }
}


// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Brep.js